const state = {
  route: { path: '/' },
  appDataLoaded: false,
  routeKey: 'a',
  mixpanelConfig: {
    token: '679f523c8fefadfb7d4627a4456eabf1',
    proxyDomain: 'https://proxy-s2qfilzjba-uc.a.run.app'
  },
  showConsoleErrorsForUsers: ['67402520-0edf-4757-a620-a3f2c29c0199'],
  logoUrlDark: '',
  logoUrlLight: '',
  faviconurl: '',
  snailblastLogo:
    'https://res.cloudinary.com/mycreativeshop/image/upload/v1721396535/public/sb-logo.svg',
  webUrl: '',
  dashboardUrl: '',
  numDialogsOpen: 0,
  pageLoading: false,
  blockUILoading: false,
  runas: localStorage.getItem('runas'),
  stripePublicKey: '',
  helpscoutReady: false,
  disableAlertBar: false,
  inDevEnv: process.env.VUE_APP_IN_DEV === 'true',
  enable3dPreviews: true,
  metaPixelId: ''
};

const getters = {
  logo(state) {
    return state.logoUrlDark;
  },

  enableSubscriptions(state, getters, rootState, rootGetters) {
    if (rootGetters['user/isTeamsUser'] && !rootGetters['user/isCollectionOwner']) return false;
    return rootGetters['user/isMCS'];
  },

  catalogUrl(state) {
    return state.webUrl + 'templates';
  },

  anyDialogsOpen(state) {
    return state.numDialogsOpen > 0;
  },

  runas(state) {
    return state.runas;
  },

  analytics(state, getters, rootState, rootGetters) {
    var obj = {
      id: 'UA-12325337-1',
      gtagId: 'G-J3NTCS3ZNQ',
      conversionTrackingTag: 'AW-971600927/HEcCCLSCioEZEJ_opc8D',
      // The bare Ads tag id, without the conversion label. Registering THIS as a gtag
      // destination is what builds remarketing lists; the labelled value above only reports
      // conversions. MCS-only — MissionPrint has no Google Ads account of its own.
      googleAdsConversionId: 'AW-971600927'
    };
    if (rootGetters['user/isMissionPrint']) {
      obj.gtagId = 'GTM-57MCG99M';
      obj.conversionTrackingTag = 'G-H5HY5Y6GD2';
      obj.googleAdsConversionId = null;
    }
    return obj;
  },

  page_loading(state) {
    return !!state.pageLoading;
  }
};

const mutations = {
  SET_APP_DATA_LOADED(state, payload) {
    state.appDataLoaded = payload;
  },

  SET_ROUTE(state, payload) {
    state.route = payload;
  },

  REFRESH_CURRENT_ROUTE(state) {
    state.routeKey = state.routeKey === 'a' ? 'b' : 'a';
  },

  SET_APP_DATA(state, payload) {
    state.logoUrlDark = payload.logoUrlDark;
    state.logoUrlLight = payload.logoUrlLight;
    state.faviconUrl = payload.faviconUrl;
    state.webUrl = payload.webUrl;
    state.dashboardUrl = payload.dashboardUrl.slice(0, -1);
    state.stripePublicKey = payload.stripePublicKey;
    state.metaPixelId = payload.metaPixelId || '';
  },

  SET_DARK_LOGO_URL(state, url) {
    state.logoUrlDark = url;
  },

  INCREMENT_DIALOGS_OPEN(state) {
    state.numDialogsOpen++;
  },

  DECREMENT_DIALOGS_OPEN(state) {
    state.numDialogsOpen--;
  },

  SET_PAGE_LOADING(state, loading) {
    state.pageLoading = loading;
  },

  SET_BLOCK_UI_LOADING(state, loading) {
    state.blockUILoading = loading;
  },

  SET_RUNNING_AS(state, user) {
    state.runas = user;
    if (!user) {
      localStorage.removeItem('runas');
      document.cookie =
        'runas=;path=/;domain=mycreativeshop.com;expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
  },

  SET_HELPSCOUT_READY(state) {
    state.helpscoutReady = true;
  },

  SET_DISABLE_ALERT_BAR(state, val) {
    state.disableAlertBar = val;
  },

  SET_ENABLE_3D_PREVIEWS(state, val) {
    state.enable3dPreviews = val;
  }
};

const actions = {
  getAppData({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('data/getAppData')
        .then((response) => {
          commit('SET_APP_DATA', response.data);
          commit('user/INIT_APP_DATA', response.data, { root: true });
          commit('templates/SET_CATEGORIES', response.data.categories, { root: true });
          commit('templates/SET_CORE_PRODUCTS', response.data.coreProducts, { root: true });
          commit('templates/SET_DESIGN_GROUPS', response.data.designGroups, { root: true });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getOpenAppData({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('data/getOpenAppData')
        .then((response) => {
          commit('SET_APP_DATA', response.data);
          commit('user/INIT_MASTER_ACCOUNT', response.data.masterAccount, { root: true });
          commit('templates/SET_CATEGORIES', response.data.categories, { root: true });
          commit('templates/SET_CORE_PRODUCTS', response.data.coreProducts, { root: true });
          commit('templates/SET_DESIGN_GROUPS', response.data.designGroups, { root: true });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
